import i18n from "../i18n";
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      control: false,
      canEdit: true,
      canDelete: true,
      canShow: true,
      canAdd: true,
      total: [],

      paginations: {
        current_page: 1,
        last_page: 1,
        items_per_page: 20,
      },

      model_1: {
        show_model: false,
        model_img_src: "",
      },
      continents: [
        {
          id: "africa",
          name: i18n.t("africa"),
        },
        {
          id: "asia",
          name: i18n.t("asia"),
        },
        {
          id: "europe",
          name: i18n.t("europe"),
        },
        {
          id: "south_america",
          name: i18n.t("south_america"),
        },
        {
          id: "north_america",
          name: i18n.t("north_america"),
        },
        {
          id: "australia",
          name: i18n.t("australia"),
        },
      ],
      preferredLanguages: [
        {
          id: "ar",
          name: i18n.t("ar"),
        },
        {
          id: "en",
          name: i18n.t("en"),
        },
      ],
      genders: [
        {
          id: "male",
          name: i18n.t("male"),
        },
        {
          id: "female",
          name: i18n.t("female"),
        },
      ],
      userTypes: [
        {
          id: "player",
          name: i18n.t("labels.player"),
        },
        {
          id: "parent",
          name: i18n.t("labels.parent"),
        },
        {
          id: "events",
          name: i18n.t("labels.events"),
        },
        {
          id: "specific",
          name: i18n.t("labels.specific"),
        },
        {
          id: "coach",
          name: i18n.t("labels.coach"),
        },
      ],
    };
  },
  methods: {
    helper_validEmail(email) {
      let re =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    getRandomColor() {
      let colors = [
        {
          first: "#62EAE1",
          secound: "rgba(126, 229, 223, 0)",
        },
        {
          first: "#FF6370",
          secound: "rgba(255, 99, 112, 0)",
        },
        {
          first: "#9E62EA",
          secound: " #B199ED",
        },
        {
          first: "#EABC62",
          secound: "#E9BA62",
        },
      ];
      let random = Math.floor(Math.random() * 4);

      return { colors: colors[random], id: random };
    },

    helper_boolToText(val) {
      if (this.$store.getters["lang_module/lang"] == "en") {
        if (val) return "Yes";
        else return "No";
      } else {
        if (val) return "نعم";
        else return "لا";
      }
    },

    transStatus(status) {
      if (this.$store.getters["lang_module/lang"] == "ar") {
        if (status == "driver_finished") {
          return "تم الانتهاء ";
        }
        if (status == "client_canceled") {
          return "تم الالغاء من قبل العميل";
        }
        if (status == "driver_arrived_location") {
          return "وصل السائق";
        }
        if (status == "client_receive_offers") {
          return "استقبل العميل العروض";
        }
        if (status == "driver_start_order") {
          return "تم بدأ الرحلة";
        }
        if (status == "driver_in_the_way") {
          return "السائق في الطريق";
        }
        if (status == "driver_picked_up_package") {
          return "السائق استلم الطلب";
        }
        if (status == "driver_transferred") {
          return "تم توصيل الطلب";
        }
      } else {
        if (status == "driver_finished") {
          return "Finished ";
        }
        if (status == "client_canceled") {
          return "Cancelled By Client";
        }
        if (status == "driver_arrived_location") {
          return "Driver Arrived";
        }
        if (status == "client_receive_offers") {
          return "Client Have Orders";
        }
        if (status == "driver_start_order") {
          return "Trip Started";
        }
        if (status == "driver_in_the_way") {
          return "Driver In Way";
        }
        if (status == "driver_picked_up_package") {
          return "Driver Have Request";
        }
        if (status == "driver_transferred") {
          return "Order Have Deliverd";
        }
      }
    },

    genderText(gender) {
      if (this.$store.getters["lang_module/lang"] == "ar") {
        if (gender == "male") return "ذكر";
        if (gender == "female") return "انثي";
        else return "لا يوجد";
      } else {
        if (gender == "male") return "Male";
        if (gender == "female") return "Female";
        else return "Not Found";
      }
    },
    companyType(type) {
      if (this.$store.getters["lang_module/lang"] == "ar") {
        if (type == "individual") return "شخصي";
        if (type == "company") return "شركه";
        else return "لا يوجد";
      } else {
        if (type == "individual") return "Individual";
        if (type == "company") return "Company";
        else return "Not Found";
      }
    },
    show_model_1(src) {
      this.model_1.model_img_src = src;
      this.model_1.show_model = true;
    },
    //English
    isEnglish(e) {
      let char = String.fromCharCode(e.keyCode);
      if (/^[\u0621-\u064A]+$/.test(char)) {
        e.preventDefault();
        this.$iziToast.error({
          timeout: 2000,
          displayMode: 2,
          message: this.$t("validation.appLangEn"),
          position: "bottomRight",
        });
      }
    },
    isArabic(e) {
      let char = String.fromCharCode(e.keyCode);
      if (/^[A-Za-z]+$/.test(char)) {
        e.preventDefault();
        this.$iziToast.error({
          timeout: 2000,
          displayMode: 2,
          message: this.$t("validation.appLangAr"),
          position: "bottomRight",
        });
      }
    },
    isEmailValid(e) {
      let char = String.fromCharCode(e.keyCode);
      if (/^[\u0621-\u064A]+$/.test(char)) {
        e.preventDefault();
        this.$iziToast.error({
          timeout: 2000,
          displayMode: 2,
          message: this.$t("validation.appLangEn"),
          position: "bottomRight",
        });
      } else {
        return true;
      }
    },
    preventMinus(e) {
      let inputElement = e.target;
      if (!inputElement.checkValidity()) {
        inputElement.value = "";
      }
    },
    async publicDeleteAction(control, id, redirectTo) {
      try {
        const result = await this.$swal({
          title: this.$t("areYouSure"),
          text: this.$t("youWillNotBeAbleToGoBackInTheProcess"),
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          cancelButtonText: this.$t("cancel"),
          confirmButtonText: this.$t("delete"),
        });
        if (!result.isConfirmed) {
          return false;
        }
        await this.axios.delete(`/${control}/${id}`);

        await this.$swal({
          title: this.$t("deletedSuccessfully"),
          icon: "success",
          confirmButtonColor: "#3085d6",
          confirmButtonText: this.$t("ok"),
        });
        if (redirectTo) {
          this.$router.push(redirectTo);
        }
        return true;
      } catch (err) {
        console.log(err);
        const message =
          err.response?.data?.message ||
          err.response?.data?.messages ||
          this.$t("somethingWentWrong");

        await this.$swal({
          title: message,
          icon: "error",
          confirmButtonColor: "#d33",
          confirmButtonText: this.$t("cancel"),
        });

        return false;
      }
    },
    async publicArchiveAction(control, id, body, redirectTo) {
      try {
        const hasBody =
          body && typeof body === "object" && Object.keys(body).length > 0;
        const formData = new FormData();
        const url = hasBody ? `${control}` : `${control}/${id}/archived`;
        if (hasBody) {
          Object.entries(body).forEach(([key, value]) => {
            formData.append(key, value);
          });
        }
        // End:: Build URL
        const result = await this.$swal({
          title: this.$t("areYouSure"),
          // text: this.$t("youWillNotBeAbleToGoBackInTheProcess"),
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          cancelButtonText: this.$t("cancel"),
          confirmButtonText: this.$t("ok"),
        });
        if (!result.isConfirmed) {
          return false;
        }
        // await this.axios.post(`/${url}`, body);
        await this.axios({
          method: "POST",
          url,
          data: formData,
          headers: { "Content-Type": "multipart/form-data" },
        });

        await this.$swal({
          title: this.$t("archivedSuccessfully"),
          icon: "success",
          confirmButtonColor: "#3085d6",
          confirmButtonText: this.$t("ok"),
        });
        if (redirectTo) {
          // console.log("redirecting to", redirectTo);
          this.$router.push({ path: redirectTo });
        }
        return true;
      } catch (err) {
        // console.log(err);
        const message =
          this.$t(`${err.response?.data?.message}`) ||
          err.response?.data?.messages ||
          this.$t("something_went_wrong");
        err.response?.data?.messages || this.$t("something_went_wrong");

        await this.$swal({
          title: message,
          icon: "error",
          confirmButtonColor: "#d33",
          confirmButtonText: this.$t("cancel"),
        });

        return false;
      }
    },
    showUpgradePlanAlert() {
      return this.$swal({
        title: this.$t("upgrade_plan") || "Upgrade Required",
        text:
          this.$t("upgrade_plan_message") || "Please upgrade to another plan",
        icon: "warning",
        confirmButtonColor: "#3085d6",
        confirmButtonText: this.$t("ok") || "OK",
      });
    },
    getPackageType() {
      // console.log("getPackageType", this.currentUser.package_type);
      if (this.currentUser.package_type == 600) {
        return "premium";
      }
      return "not_premium";
    },
    isPremium() {
      if (this.currentUser.package_type == 600) {
        return true;
      }
      return false;
    },
    playerCompleteSubsccriptionAlert() {
      this.$swal({
        icon: "info",
        title: this.$t("labels.paymentComplete"),
        text: this.$t("labels.paymentCompleteMessage"),
        confirmButtonText: this.$t("ok") || "OK",
        confirmButtonColor: "#f59e0b",
      });
    },
    stripHtml(html) {
      if (!html) return "";

      const formattedHtml = html
        .replace(/<br\s*\/?>/gi, "\n")
        .replace(/<\/(p|div|h[1-6]|li)>/gi, "\n");

      const documentObject = new DOMParser().parseFromString(
        formattedHtml,
        "text/html"
      );

      return documentObject.body.textContent
        .replace(/\n\s*\n\s*\n+/g, "\n\n")
        .trim();
    },
    translateDays(message) {
      return message.replace(
        /\b(Sunday|Monday|Tuesday|Wednesday|Thursday|Friday|Saturday)\b/g,
        (day) => this.$t(`days.${day}`)
      );
    },
    translateDayInMessage(message) {
      const daysRegex =
        /\b(Sunday|Monday|Tuesday|Wednesday|Thursday|Friday|Saturday)\b/i;

      // 1. Extract the day
      const match = message.match(daysRegex);

      if (!match) return message;

      const day = match[0];

      const translatedDay = this.$t(`days.${day}`);
      return translatedDay;
    },
    extractTimeRange(message) {
      return (
        message.match(/\(\s*\d{1,2}:\d{2}\s*-\s*\d{1,2}:\d{2}\s*\)/)?.[0] ||
        null
      );
    },
  },

  computed: {
    ...mapGetters("auth_module", ["currentUser"]),
  },
};
